import firebase from "../../firebase";

export default function({ officeId, roomIds }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingAdmin",
        funcName: "reorderRooms",
        data: {
            officeId,
            roomIds
        }
    });
}
